import { Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PageHeaderComponent } from '@nucleus/ui-base';

@Component({
    selector: 'app-about-us',
    imports: [MatDialogModule, MatIconModule, MatButtonModule, MatTooltipModule, PageHeaderComponent],
    templateUrl: './about-us.component.html',
    styleUrl: './about-us.component.css'
})
export class AboutUsComponent {}
